import { inject, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './auth/services/auth.guard';
import { PagesResolverService } from './pages/pages-resolver.service';

const routes: Routes = [
  {
    path: 'pages',
    loadChildren: () => import('./pages/pages.module').then((m) => m.PagesModule),
    canActivate: [() => inject(AuthGuard).canActivate()],
    resolve: {
      PagesResolverService
    }
  },
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule),
  },
  { path: '', redirectTo: 'pages', pathMatch: 'full' },
  { path: '**', redirectTo: 'pages' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: false,
      onSameUrlNavigation: 'reload',
      initialNavigation: 'enabledNonBlocking', // The initial navigation starts after the root component has been created. The bootstrap is not blocked on the completion of the initial navigation
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
